module.exports = __webpack_public_path__ + "img/logo-80px.8fc7419f.png";